module.exports = __webpack_public_path__ + "img/barnard_6.0b517785.jpg";